// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-loc-label,
.em-loc-label-halo {
    stroke-linejoin: round;
    stroke-linecap: round;
    font-family: Arial, Helvetica, sans-serif;
    dominant-baseline: central;
    pointer-events: none;
    paint-order: stroke fill;
}
`, "",{"version":3,"sources":["webpack://./src/css/locations.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;IACtB,qBAAqB;IACrB,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,wBAAwB;AAC5B","sourcesContent":[".em-loc-label,\r\n.em-loc-label-halo {\r\n    stroke-linejoin: round;\r\n    stroke-linecap: round;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    dominant-baseline: central;\r\n    pointer-events: none;\r\n    paint-order: stroke fill;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
